import React from 'react';
import { observer } from 'src/utils/mobx-react';
import { Resource } from 'src_common/common/mobx-utils/Resource';
import { BadgeColored } from 'src/components/CustomersBar/CustomerTab/CustomerSummaryTab/CustomerSummaryTab.style';
import { CustomerSummaryTabAffordabilityState } from 'src/components/CustomersBar/CustomerTab/CustomerSummaryTab/CustomerSummaryTabAffordability/CustomerSummaryTabAffordability.state';
import { OpenapiProxyStaffAccountAffordabilityResponse200Type } from 'src/api_openapi/generated/openapi_proxy_staff_account_affordability';
import { getDepositLimits } from 'src_server/types/responsibleGambling';
import { ConfigState } from 'src/AppState/ConfigState/ConfigState';
import { useCommon } from 'src/AppState/Common';

interface CustomerSummaryTabSummaryOptionsType {
    affordabilityStatusResource: Resource<OpenapiProxyStaffAccountAffordabilityResponse200Type>;
    depositLimitsResource: Resource<getDepositLimits.ResponseType> | null;
}

export const CustomerSummaryTabAffordability = observer(
    'CustomerSummaryTabAffordability',
    ({ affordabilityStatusResource, depositLimitsResource }: CustomerSummaryTabSummaryOptionsType) => {
        const common = useCommon();
        const { isAffordability } = ConfigState.get(common).config;

        const [state] = React.useState(
            () => new CustomerSummaryTabAffordabilityState(affordabilityStatusResource, depositLimitsResource)
        );

        if (isAffordability) {
            return (
                <li key='Affordability'>
                    <strong>Affordability:</strong>
                    {state.affordabilityStatus?.affordabilityColor !== undefined &&
                    state.resultBadge === 'colorBadge' ? (
                        <BadgeColored
                            badgeColor={state.affordabilityStatus.affordabilityColor?.toLowerCase() ?? ''}
                            data-test='account-status-affordability'
                        >
                            {state.affordabilityStatus.affordabilityColor?.toUpperCase()}
                        </BadgeColored>
                    ) : null}

                    {state.resultBadge === 'depositBadge' ? (
                        <BadgeColored
                            badgeColor='gray'
                            data-test='account-status-affordability'
                        >
                            {`${state.rollingDepositLimits} NOT CHECKED YET`}
                        </BadgeColored>
                    ) : null}

                    {state.resultBadge === 'depositBadgeDefault' ? (
                        <BadgeColored
                            badgeColor='gray'
                            data-test='account-status-affordability'
                        >
                            {`${state.rollingDepositLimits} NOT CHECKED YET`}
                        </BadgeColored>
                    ) : null}
                </li>
            );
        }
        return null;
    }
);
